
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// router的配置
import './permission'
// 引入element-ui插件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// swiper的css
// import 'swiper/dist/css/swiper.css'
import 'swiper/swiper-bundle.css';

// 引入vuex配置
import store from './store'
// 全局引入工具类
import Utils from '@/utils/utils.js'
// 全局常量
import Constant from '@/api/constant.js'
// ajax
import request from '@/utils/request'

//wx的jssdk
import wx from 'weixin-jsapi'

import '@/assets/font-icon/iconfont.css'

import {Dialog} from 'vant';
import 'vant/lib/index.css';

/** 引入echarts */
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts
import { SwipeCell, Button} from 'vant';
import { Col, Row, Icon  } from 'vant';

Vue.use(SwipeCell).use(Button).use(Col).use(Row).use(Icon);

Vue.prototype.$wx = wx
// import Breadcrumb from '@/components/commonBreadcrumb'
import bus from '@/utils/bus.js'
Vue.prototype.$bus = bus;
Vue.config.productionTip = false
Vue.use(ElementUI)


import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad)

//loadingModel
// import Loading from '@/components/loading/loading.js'

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
  
Vue.use(VideoPlayer)



// Vue.use(Loading)
// Vue.use(Breadcrumb)

Vue.prototype.$vDialog = Dialog
Vue.prototype.$utils = Utils
Vue.prototype.$axios = request
Vue.prototype.$constant = Constant

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js